import React from 'react';
import { Button, Col, Form, Input, Row, notification } from 'antd';
import { useChangePasswordMutation } from '../../../app/api/userApiSlice';

const ChangePassword: React.FC = () => {
  const [form] = Form.useForm();
  const [changePassword, { isLoading: changePasswordLoading }] = useChangePasswordMutation();

  const onFinish = (values: any): void => {
    changePassword(values)
      .unwrap()
      .then((result) => {
        notification.success({
          message: 'Success',
          description: 'Password changed successfully',
        });
        // Reset form fields
        form.resetFields();
      })
      .catch((error: any) => {
        console.log(error)
      });
  };

  return (
    <>
      <Row gutter={16}>
        <Col span={8}>
          <Form onFinish={onFinish} form={form} layout='vertical'>
            <Form.Item
              label='Current Password'
              name='currentPassword'
              rules={[{ required: true, message: 'Please input your old password!' }]}
            >
              <Input.Password />
            </Form.Item>
            <Form.Item
              label='New Password'
              name='newPassword'
              rules={[{ required: true, message: 'Please input your new password!' }]}
            >
              <Input.Password />
            </Form.Item>
            <Form.Item
              label='Confirm Password'
              name='confirmPassword'
              rules={[
                { required: true, message: 'Please confirm your new password!' },
                ({ getFieldValue }) => ({
                  validator: async (_, value) => {
                    if (!value || getFieldValue('newPassword') === value) {
                      return await Promise.resolve();
                    }
                    return await Promise.reject(
                      new Error('The two passwords that you entered do not match!'),
                    );
                  },
                }),
              ]}
            >
              <Input.Password />
            </Form.Item>
            <Form.Item>
              <Button type='primary' htmlType='submit' loading={changePasswordLoading}>
                Submit
              </Button>
            </Form.Item>
          </Form>
        </Col>
      </Row>
    </>
  );
};

export default ChangePassword;
